import { render, staticRenderFns } from "./LessThan10.vue?vue&type=template&id=42d16aab&"
import script from "./LessThan10.vue?vue&type=script&lang=js&"
export * from "./LessThan10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports